import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { FileSearch, Eye, ShieldAlert, Network, Lightbulb, Zap, HardHat, Package, Mountain, Wrench, Building2, Zap as EnergyIcon, Binary, Users } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function LightSections() {
  return <div className="bg-light text-navy" data-id="element-280" data-mp="1xzzqe3igm5xw">
      {/* PROBLEMA */}
      <section id="problema" className="py-24" data-id="element-281" data-mp="1t1g0js0qwa09">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-282" data-mp="1szlkar0f562i">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-283" data-mp="1oyjf7tjtlzsm">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-6 leading-tight" data-id="element-284" data-mp="dlpbiqdugfjn">
              Las licitaciones no se ganan en terreno.
              <br data-id="element-285" data-mp="io8f495h3a54" />
              <span className="text-techblue" data-id="element-286" data-mp="inqez1fowbrx">
                Se ganan entendiendo mejor la información.
              </span>
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed max-w-3xl mx-auto" data-id="element-287" data-mp="nmjrorn5jyr1">
              Cada licitación importante contiene cientos de planos,
              especificaciones, contratos, anexos y respuestas a consultas. Los
              equipos de propuestas tienen días o semanas para encontrar
              información crítica mientras compiten contra múltiples empresas.
              Las decisiones incorrectas generan pérdidas millonarias.
            </p>
          </motion.div>
        </div>
      </section>

      {/* INSIGHT */}
      <section className="py-24 bg-white border-y border-slate-200" data-id="element-288" data-mp="3r3s3ouv784du">
        <div className="container mx-auto px-4" data-id="element-289" data-mp="3r1yup8x4582o">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center mb-16" data-id="element-290" data-mp="3d5bosgn6n7km">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight leading-tight" data-id="element-291" data-mp="1nog5spqckzv0">
              Las empresas creen que están estudiando una licitación.
              <br data-id="element-292" data-mp="1eu1uszcuobhp" />
              <span className="text-slate-500" data-id="element-293" data-mp="1evmjw9geb286">
                En realidad están tomando una decisión financiera.
              </span>
            </h2>
          </motion.div>

          <div className="max-w-5xl mx-auto" data-id="element-294" data-mp="26mao5udd8nq2">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-8" data-id="element-295" data-mp="26jwspkerx9hz">
              <div className="flex-1 bg-slate-50 p-8 rounded-xl border border-slate-200 text-center w-full" data-id="element-296" data-mp="22ib79ao6bmw6">
                <div className="text-techblue font-semibold mb-2" data-id="element-297" data-mp="1xn5qsrdjj0fh">Paso 1</div>
                <div className="text-xl font-bold" data-id="element-298" data-mp="1slzw4o0bl33b">Documentos</div>
              </div>

              <motion.div initial={{
              width: 0,
              opacity: 0
            }} whileInView={{
              width: 40,
              opacity: 1
            }} viewport={{
              once: true
            }} className="hidden md:block h-0.5 bg-slate-300 relative" data-id="element-299" data-mp="m7qttnlc08kd">
                <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 border-t-2 border-r-2 border-slate-300 rotate-45" data-id="element-300" data-mp="gzqylefuenow" />
              </motion.div>

              <div className="flex-1 bg-slate-50 p-8 rounded-xl border border-slate-200 text-center w-full" data-id="element-301" data-mp="puf67b8w4hgv">
                <div className="text-techblue font-semibold mb-2" data-id="element-302" data-mp="urp3te6fnzfs">Paso 2</div>
                <div className="text-xl font-bold" data-id="element-303" data-mp="zra3jqtfgbtk">Decisiones</div>
              </div>

              <motion.div initial={{
              width: 0,
              opacity: 0
            }} whileInView={{
              width: 40,
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="hidden md:block h-0.5 bg-slate-300 relative" data-id="element-304" data-mp="14qwjw94jy86l">
                <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 border-t-2 border-r-2 border-slate-300 rotate-45" data-id="element-305" data-mp="vx8nyse1pvyk" />
              </motion.div>

              <div className="flex-1 bg-navy text-white p-8 rounded-xl border border-navy text-center w-full shadow-lg" data-id="element-306" data-mp="14wvq5geln5so">
                <div className="text-cyan font-semibold mb-2" data-id="element-307" data-mp="h69ms2fji9p0">Paso 3</div>
                <div className="text-xl font-bold" data-id="element-308" data-mp="d5pm4ovrcny4">Resultado económico</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SUPERPODER */}
      <section className="py-24" data-id="element-309" data-mp="m4uj3qro8986">
        <div className="container mx-auto px-4" data-id="element-310" data-mp="m3ruxqlqgkvy">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center max-w-3xl mx-auto mb-16" data-id="element-311" data-mp="3uke9mi0yjdjj">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight leading-tight mb-6" data-id="element-312" data-mp="252hfkmn3wjc7">
              Tu equipo sigue siendo el mismo.
              <br data-id="element-313" data-mp="1w3cdj6cc67va" />
              <span className="text-techblue" data-id="element-314" data-mp="1w45f7swfu76k">
                Su capacidad de análisis ya no.
              </span>
            </h2>
            <p className="text-lg text-slate-600" data-id="element-315" data-mp="212fcc91q3hut">
              Prisma entrega un nivel de entendimiento imposible de lograr
              manualmente bajo presión.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-316" data-mp="2ssk1el0fgt2d">
            {[{
            icon: FileSearch,
            text: 'Detecta contradicciones.'
          }, {
            icon: Eye,
            text: 'Encuentra requisitos ocultos.'
          }, {
            icon: ShieldAlert,
            text: 'Identifica riesgos contractuales.'
          }, {
            icon: Network,
            text: 'Relaciona información dispersa.'
          }, {
            icon: Lightbulb,
            text: 'Sugiere consultas estratégicas.'
          }, {
            icon: Zap,
            text: 'Resume miles de páginas en minutos.'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white p-6 rounded-xl border border-slate-200 hover:shadow-md hover:-translate-y-1 transition-all duration-300" data-id="element-317" data-mp="5lyu3pg3rvrj" data-mpi={i}>
                <item.icon className="w-8 h-8 text-techblue mb-4" data-id="element-318" data-mp="1tiy7yqjn4kqr" />
                <h3 className="text-lg font-semibold" data-id="element-319" data-mp="1tgkg0qk9bonf">{item.text}</h3>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* CÓMO FUNCIONA */}
      <section id="como-funciona" className="py-24 bg-white border-y border-slate-200" data-id="element-320" data-mp="238zw1ibzu35o">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-321" data-mp="289nnu681qo0y">
          <div className="grid md:grid-cols-3 gap-8" data-id="element-322" data-mp="1akuef4g8kua2">
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} className="relative" data-id="element-323" data-mp="1am5dws2nffvd">
              <div className="text-6xl font-bold text-slate-100 absolute -top-6 -left-4 z-0" data-id="element-324" data-mp="1okmzaj530ga4">
                1
              </div>
              <div className="relative z-10" data-id="element-325" data-mp="2vwvvgusy6965">
                <h3 className="text-xl font-bold mb-4" data-id="element-326" data-mp="2zy7koz7wssdt">Sube la licitación.</h3>
                <p className="text-slate-600 text-sm" data-id="element-327" data-mp="3m0aldobu8bfj">
                  Carga todos los documentos sin importar el formato o volumen.
                </p>
              </div>
            </motion.div>

            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            delay: 0.2
          }} className="relative" data-id="element-328" data-mp="3vq3wko82ioj9">
              <div className="text-6xl font-bold text-slate-100 absolute -top-6 -left-4 z-0" data-id="element-329" data-mp="3mt6m9kozabk">
                2
              </div>
              <div className="relative z-10" data-id="element-330" data-mp="ii982znlq8hz">
                <h3 className="text-xl font-bold mb-4" data-id="element-331" data-mp="dkhf02b80gc7">Prisma analiza:</h3>
                <div className="flex flex-wrap gap-2" data-id="element-332" data-mp="dl92epunz7re">
                  {['bases administrativas', 'bases técnicas', 'contratos', 'memorias', 'planos', 'anexos', 'consultas'].map(chip => <span key={chip} className="px-3 py-1 bg-slate-100 text-slate-700 text-xs font-medium rounded-full border border-slate-200" data-id="element-333" data-mp="zt61w9u8ynz0">
                      {chip}
                    </span>)}
                </div>
              </div>
            </motion.div>

            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            delay: 0.4
          }} className="relative" data-id="element-334" data-mp="c5emgxdetuti">
              <div className="text-6xl font-bold text-slate-100 absolute -top-6 -left-4 z-0" data-id="element-335" data-mp="1wj5imrkjwsso">
                3
              </div>
              <div className="relative z-10" data-id="element-336" data-mp="21ii3x7vrxrt5">
                <h3 className="text-xl font-bold mb-4" data-id="element-337" data-mp="21g5op2hehvjs">Obtén:</h3>
                <ul className="space-y-2" data-id="element-338" data-mp="35y0ek35ckewv">
                  {['riesgos', 'alertas', 'contradicciones', 'oportunidades', 'inteligencia accionable'].map(item => <li key={item} className="flex items-center gap-2 text-sm font-medium text-navy" data-id="element-339" data-mp="31y9roaixyixm">
                      <div className="w-1.5 h-1.5 rounded-full bg-techblue" data-id="element-340" data-mp="3to4h076su8ma" />
                      <span className="capitalize" data-id="element-341" data-mp="3tm1sxsp7ipk7">{item}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* PARA QUIÉN ES */}
      <section id="para-quien" className="py-24" data-id="element-342" data-mp="2496n76r8bru6">
        <div className="container mx-auto px-4" data-id="element-343" data-mp="24bj5jl0wg47r">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center mb-16" data-id="element-344" data-mp="298sz9cvbn21e">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight" data-id="element-345" data-mp="1wpnpdudbtu1j">
              Para quién es Prisma.
            </h2>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto" data-id="element-346" data-mp="25q3razef8t4a">
            {[{
            icon: HardHat,
            text: 'Constructoras'
          }, {
            icon: Package,
            text: 'Proveedores'
          }, {
            icon: Mountain,
            text: 'Minería'
          }, {
            icon: Wrench,
            text: 'Montajes industriales'
          }, {
            icon: Building2,
            text: 'Infraestructura'
          }, {
            icon: EnergyIcon,
            text: 'Energía'
          }, {
            icon: Binary,
            text: 'Ingeniería'
          }, {
            icon: Users,
            text: 'Contratistas'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="bg-white p-6 rounded-xl border border-slate-200 flex flex-col items-center justify-center text-center gap-3 hover:border-techblue hover:shadow-sm transition-colors" data-id="element-347" data-mp="345lzk9khbzoq" data-mpi={i}>
                <item.icon className="w-8 h-8 text-slate-400" data-id="element-348" data-mp="4o46jnvpx5vw" />
                <span className="font-semibold text-sm" data-id="element-349" data-mp="4qgx2pfjkokk">{item.text}</span>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* VISIÓN */}
      <section id="vision" className="py-32 bg-white border-t border-slate-200" data-id="element-350" data-mp="1l5czfp59xu7r">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-351" data-mp="1gd32hp5qrtvz">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-352" data-mp="1bf9tkod20ls0">
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-tight mb-10" data-id="element-353" data-mp="11h3v6gqghxrw">
              Estamos construyendo el sistema operativo de inteligencia para
              licitaciones.
            </h2>
            <div className="space-y-6 text-lg md:text-xl text-slate-600 leading-relaxed" data-id="element-354" data-mp="sgpbtmx1ysr1">
              <p data-id="element-355" data-mp="2rttc7i9dj3uc">
                Nuestra visión es que ninguna empresa presente una oferta
                relevante sin pasar antes por Prisma.
              </p>
              <p data-id="element-356" data-mp="2ms3wvqf4c40g">
                Así como hoy nadie realiza una due diligence sin análisis
                financiero.
              </p>
              <p className="font-semibold text-navy" data-id="element-357" data-mp="1oivy7bc6enuw">
                Mañana nadie debería presentar una oferta sin inteligencia
                documental.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}